import {initWindow} from "./window";
import {MEDIA, SIDEBAR} from "../../constants";
import {trigger} from "../../../utils/events/trigger";

const isContentScrolled = (evt, isScrollDirectionDown) => {
	const target = evt.target.closest(`div.text-wrapper`);

	if (target)
	{
		const content = target.querySelector(`div`);
		const contentCurrentScroll = content.scrollTop;
		const contentVisibleHeight = content.offsetHeight;
		const contentFullHeight = content.scrollHeight;

		const isScrollBottomEnd = contentCurrentScroll + contentVisibleHeight === contentFullHeight;
		const isScrollTopEnd = contentCurrentScroll === 0;

		return isScrollDirectionDown ? isScrollBottomEnd : isScrollTopEnd;
	}

	return true;
};

let prevTouchPadEventStartTime = 0;
let prevDiff = 0;

export const initWheel = () => {
	window.addEventListener(`wheel`, (evt) => {
		const currentTouchPadEventStartTime = new Date().getTime();
		const currentDiff = currentTouchPadEventStartTime - prevTouchPadEventStartTime;
		const isScrollDirectionDown = evt.deltaY >= 0;
	
		if (!document.documentElement.classList.contains(`on-sliding`))
		{
			prevTouchPadEventStartTime = 0;
			prevDiff = 0;
		}
		
		if (Math.abs(currentDiff - prevDiff) > 50 && !evt.target.closest(`aside.sidebar`) && isContentScrolled(evt, isScrollDirectionDown))
		{
			initWindow(isScrollDirectionDown);
		}
		
		prevTouchPadEventStartTime = currentTouchPadEventStartTime;
		prevDiff = currentDiff;
	});
};
